import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { CONVERSATION_LIST_KEY, USE_QUERY_STALE_TIME } from 'utils';
import { AuthContext } from '@/contexts';
import { Conversation, ExtractedDataField, MetadataField } from '@/types';
import { ConversationParams } from './useConversationsQueryParams';

export interface ConversationsList {
  conversations: Conversation[];
  totalConversations: number;
  extractedDataFields?: ExtractedDataField[];
  metadataFields?: MetadataField[];
  dataKeys?: string[];
}

export function useConversationsList(
  id: string,
  params: ConversationParams,
  fetch: () => Promise<ConversationsList>,
) {
  const authContext = useContext(AuthContext);

  const query = useQuery<ConversationsList>({
    queryKey: [
      CONVERSATION_LIST_KEY,
      id,
      params.page,
      params.search,
      params.sortBy,
      params.sortDir,
      params.filters,
    ],
    queryFn: fetch,
    staleTime: USE_QUERY_STALE_TIME,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled: authContext.isAuthenticated,
  });

  return query;
}
